module.exports = __webpack_public_path__ + "img/叶坪红军烈士纪念亭.195b6e76.png";